import { CashMovementHistory } from "../../types/cash/movement";
import { CustomColumn } from "../../types/customColumn";

export const cashIncomeColumns: CustomColumn<CashMovementHistory>[] = [

  {
    Header: "Fecha",
    accessor: "movementDate",
    customCell: ({ row }) => (
      <span className="text-sm text-gray-700 dark:text-gray-300">
        {row.original.movementDate}
      </span>
    ),
  },

  {
    Header: "Monto",
    accessor: "amount",
    customCell: ({ row }) => (
      <span className="text-sm font-semibold text-green-600">
        ${row.original.amount.toFixed(2)}
      </span>
    ),
  },

  {
    Header: "Descripción",
    accessor: "description",
    customCell: ({ row }) => (
      <span className="text-sm text-gray-700 dark:text-gray-300">
        {row.original.description || "-"}
      </span>
    ),
  },

  {
    Header: "Usuario",
    accessor: "createdByName",
    customCell: ({ row }) => (
      <span className="text-sm font-medium text-black dark:text-white">
        {row.original.createdByName}
      </span>
    ),
  },

];